import { Injectable } from '@angular/core';
import userflow, { Attributes } from 'userflow.js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserflowService {
  public init(): void {
    if (!environment.userflow.enabled) {
      return;
    }
    if (!environment.userflow.token) {
      throw new Error('Userflow token is not defined');
    }
    userflow.init(environment.userflow.token);
  }

  public identify(userId: string, attributes: Attributes): void {
    if (!environment.userflow.enabled) {
      return;
    }
    userflow.identify(userId, attributes);
  }

  public reset(): void {
    if (!environment.userflow.enabled) {
      return;
    }
    userflow.reset();
  }
}
